var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgAsana = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.784 6.70609C16.784 9.30406 14.6423 11.4122 12.0008 11.4122C9.3577 11.4122 7.21597 9.3057 7.21597 6.70609C7.21597 4.10648 9.3577 2 12.0008 2C14.6423 2 16.784 4.10648 16.784 6.70609ZM5.78483 12.5879C3.14338 12.5879 1 14.6944 1 17.2924C1 19.8903 3.14171 21.9985 5.78483 21.9985C8.42795 21.9985 10.5697 19.892 10.5697 17.2924C10.5697 14.6944 8.42795 12.5879 5.78483 12.5879ZM18.2152 12.5879C15.572 12.5879 13.4303 14.6944 13.4303 17.2939C13.4303 19.8935 15.572 22 18.2152 22C20.8565 22 23 19.8935 23 17.2939C23 14.6944 20.8583 12.5879 18.2152 12.5879Z",
    fill: "#FF584A"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAsana);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Asana.62c45f38e962395bd74d5fb98211d296.svg";